import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import css from './SemiFinishedAddProductModal.module.css';
import { productsActions } from "../../../../store/slices/settings-slices";
import { semiFinishedProductsActions } from "../../../../store/slices/semiFinished-slice";

const SemiFinishedUpdateProductModal = ({
    productId,
    setProductUpdateOpen,
    weight,
    weightNetto,
}) => {
    const [selectedProduct, setSelectedProduct] = useState(null);
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;

    const { productsArray, trigger } = useSelector(store => store.products);
    const { semiFinishedProductsForModalArray } = useSelector(store => store.semiFinishedProducts);

    const [localWeight, setLocalWeight] = useState(weight);
    const [localWeightNetto, setLocalWeightNetto] = useState(weightNetto);

    useEffect(() => {
        dispatch(productsActions.getAllProducts());
    }, [trigger, dispatch]);

    useEffect(() => {
        if (productsArray.length > 0 && productId) {
            setSelectedProduct(productsArray.find(obj => obj.id === productId));
        }
    }, [productsArray, productId]);

    const handleUpdateSubmit = async (e, data) => {
        e.preventDefault();
        try {
            if (!selectedProduct) return;

            const newWeight = Number(data.weight);
            let newWeightNetto;

            if (data.weightNetto && Number(data.weightNetto) > 0) {
                newWeightNetto = Number(data.weightNetto);
            } else {
                const originalWeight = parseFloat(selectedProduct.weight) || 0;
                const originalWeightNetto = parseFloat(selectedProduct.weightNetto) || 0;
                const nettoRatio = originalWeight > 0 ? originalWeightNetto / originalWeight : 0;
                newWeightNetto = Number((newWeight * nettoRatio).toFixed(2));
            }

            const updatedItem = {
                id: selectedProduct.id,
                name: selectedProduct.name,
                weight: newWeight,
                weightNetto: newWeightNetto,
                cost: Number(((selectedProduct.price / 1000) * newWeight).toFixed(2)),
                product: {
                    energy: Number(((selectedProduct.energy * newWeight) / 100).toFixed(2)),
                    fats: Number(((selectedProduct.fats * newWeight) / 100).toFixed(2)),
                    proteins: Number(((selectedProduct.proteins * newWeight) / 100).toFixed(2)),
                    carbohydrates: Number(((selectedProduct.carbohydrates * newWeight) / 100).toFixed(2)),
                },
            };

            const updatedArray = semiFinishedProductsForModalArray.map(item => {
                if (item.productId === productId || item.id === productId) {
                    return updatedItem;
                }
                return item;
            });

            dispatch(semiFinishedProductsActions.updateSemiFinishedProductsForModal(updatedArray));
            dispatch(semiFinishedProductsActions.changeTrigger());
            setProductUpdateOpen(false);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <section className={css.overlay}>
            <div className={css.modal}>
                <button
                    className={css.closeButton}
                    onClick={() => setProductUpdateOpen(false)}
                >
                    &times;
                </button>
                <h2 className={css.title}>Update Product</h2>

                <form className={css.content}>
                    <div className={css.inputGroup}>
                        <label>{t('Products')}</label>
                        <h2>
                            {selectedProduct?.name[currentLanguage] ||
                                selectedProduct?.name?.['en']}
                        </h2>
                    </div>

                    <div className={css.inputGroup}>
                        <label htmlFor="weight">{t('Weight')}</label>
                        <input
                            type="number"
                            id="weight"
                            value={localWeight}
                            onChange={(e) => setLocalWeight(e.target.value)}
                        />
                    </div>

                    <div className={css.inputGroup}>
                        <label htmlFor="weightNetto">{t('WeightNetto')}</label>
                        <input
                            type="number"
                            id="weightNetto"
                            value={localWeightNetto}
                            onChange={(e) => setLocalWeightNetto(e.target.value)}
                        />
                    </div>

                    <div className={css.actions}>
                        <button
                            type="button"
                            className={css.cancelButton}
                            onClick={() => setProductUpdateOpen(false)}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={css.okButton}
                            onClick={(e) =>
                                handleUpdateSubmit(e, {
                                    weight: localWeight,
                                    weightNetto: localWeightNetto,
                                })
                            }
                        >
                            OK
                        </button>
                    </div>
                </form>
            </div>
        </section>
    );
};

export { SemiFinishedUpdateProductModal };
